import * as React from 'react';
import PropTypes from 'prop-types';

import { Icon, Table } from 'antd';

import { getLocationQuery, getUrlSearch } from 'shared/utils/url';
import { routeGenerator } from 'routes';
import { saveUserInfo, searchUsers } from 'Root/http';
import Search from 'shared/components/Search/Search';
import Loader from 'shared/components/Loader/Loader';

import EditUserModal from './EditUserModal';
import s from './style/Users.pcss';


const pageSize = 10;
const columns = [
  {
    title: 'Имя',
    dataIndex: 'fullName',
    width: '25%',
    render: (text, record) => (
      <div className={s.nameContainer}>
        <div className={s.name}>{text}</div>
        {record.groupArray &&
          <div className={s.tagList}>
            {record.groupArray.map(group => (
              <div key={group.id} className={s.tagItem}>{group.name}</div>
            ))}
          </div>
        }
      </div>
    ),
  },
  {
    title: 'E-mail',
    dataIndex: 'email',
    width: '15%',
  },
  {
    title: 'Должность',
    dataIndex: 'positionName',
    width: '15%',
    render: text => text || 'Не известно',
  },
  {
    title: 'Подразделение',
    dataIndex: 'fetch.unitId.unitId.name',
    width: '20%',
    render: text => text || 'Не известно',
  },
  {
    title: 'Роли',
    dataIndex: 'roles',
    width: '25%',
    render: text => (
      <div className={s.roleList}>
        {text.map(role => (
          <div key={role} className={s.roleItem}>{role}</div>
        ))}
      </div>
    ),
  },
];


export default class Users extends React.Component {
  static propTypes = {
    location: PropTypes.shape().isRequired,
    history: PropTypes.shape().isRequired,
  };

  componentWillMount() {
    this.loadData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    const query = getLocationQuery(this.props.location);
    const nextQuery = getLocationQuery(nextProps.location);
    if ((query.search !== nextQuery.search) || (query.page !== nextQuery.page)) {
      this.loadData(nextProps);
    }
  }

  state = {
    data: [],
    loading: false,
    createUserMode: false,
    total: 1,
  };


  onOpenModal = () => this.setState({ createUserMode: true });

  onCloseModal = () => this.setState({ createUserMode: false });

  loadData = (props) => {
    const { location } = props;
    const query = getLocationQuery(location);
    const querySearch = query.search || '';
    const page = query.page - 1 || 0;

    this.setState({ loading: true }, () => {
      const searchData = {
        value: querySearch,
        isForUserTab: true,
        page,
        pageSize,
      };

      searchUsers(searchData).then((res) => {
        const data = res.list
          .map(item => ({
            ...item,
            roles: item.fetch.roleArray.roleArray.map(r => r.name),
            groupArray: item.fetch.groupArray.groupArray,
          }));
        const pageInfo = res.pageInfo;
        this.setState({ data, loading: false, total: pageInfo.tableSize });
      });
    });
  };

  handleSearch = (search) => {
    const { location } = this.props;
    const query = getLocationQuery(location);
    query.search = search || undefined;
    query.page = undefined;
    this.props.history.push({
      pathname: this.props.location.pathname,
      search: getUrlSearch(query),
    });
  };

  changePage = ({ current }) => {
    const { location } = this.props;
    const query = getLocationQuery(location);
    query.page = current || undefined;
    this.props.history.push({
      pathname: this.props.location.pathname,
      search: getUrlSearch(query),
    });
  };

  createUser = data => saveUserInfo(data).then(this.onCloseModal);

  onRowClick = item =>
    this.props.history.push(routeGenerator.userRoleLink(item.id));

  render() {
    const { location } = this.props;
    const { data, createUserMode, total } = this.state;
    const query = getLocationQuery(location);
    const loading = {
      spinning: this.state.loading,
      indicator: <Loader fullScreen={false} size={20} />,
    };

    return (
      <div className={s.container}>
        <div className={s.header}>
          <div className={s.searchContainer}>
            <Search onSearch={this.handleSearch} value={query.search || ''} />
          </div>
          <div className={s.addContainer} onClick={this.onOpenModal}>
            <Icon type="plus" theme="outlined" />
            <div className={s.addBtn}>Добавить пользователя</div>
          </div>
        </div>

        <div className={s.bodyContainer}>
          <Table
            rowKey={r => r.id}
            onRow={record => ({
              onClick: () => this.onRowClick(record),
            })}
            onChange={this.changePage}
            pagination={{ current: +query.page, total }}
            loading={loading}
            columns={columns}
            dataSource={data}
            scroll={{ y: 'calc(100vh - 300px)' }}
          />
        </div>

        <EditUserModal
          onEdit={this.createUser}
          visible={createUserMode}
          onClose={this.onCloseModal}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Root/pages/Users/Users.js